const ruFooter = {
address:"Адрес",
fulladress:"г. Ташкент Чиланзарский. Заргарлик. Кизил шарк 32",
link:"Быстрые ссылки"
}
 export default ruFooter;  